
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-plane-line',
      title: 'Schengen C Tipi Vizeler',
      description: 'Kısa süreli seyahatler için Schengen C tipi vizelerde başvuru dosyası hazırlığı, randevu dağıtımı ve evrak kontrol desteği sunuyoruz.',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Schengen D Tipi Vizeler',
      description: 'Uzun süreli oturum veya eğitim amaçlı vizelerde resmi kurumlara uyumlu prosedür yönetimi ile yanınızdayız.',
    },
    {
      icon: 'ri-flag-line',
      title: 'Amerika Vizesi',
      description: 'DS-160 form hazırlığı, randevu görüşmeleri ve mülakat danışmanlığı ile Amerika vize sürecinizi kolaylaştırıyoruz.',
    },
    {
      icon: 'ri-shield-star-line',
      title: 'İngiltere Vizesi',
      description: 'Evrak hazırlığı, dilekçe desteği ve başvuru merkezi yönlendirmesi ile İngiltere vize başvurunuzu yönetiyoruz.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Oturum Kartı Başvuruları',
      description: 'AB ülkeleri başta olmak üzere oturum kartı yenileme ve ilk başvuru danışmanlığı hizmetleri sunuyoruz.',
    },
    {
      icon: 'ri-team-line',
      title: 'Göçmenlik ve Aile Birleşimi',
      description: 'Aile birleşimi, evlilik ve kalıcı göçmenlik başvurularında tüm hukuki süreç yönetimini sağlıyoruz.',
    },
    {
      icon: 'ri-door-open-line',
      title: 'Kapı Vizeleri',
      description: 'Varış noktasında alınabilen kapı vizeleri için gerekli evrak hazırlığı ve bilgilendirme desteği veriyoruz.',
    },
    {
      icon: 'ri-global-line',
      title: 'E-Vizeler',
      description: 'Dubai, Ermenistan, Kuveyt, Suudi Arabistan, Rusya, Vietnam, Küba için online e-vize başvuru hizmetleri.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Özel Danışmanlık',
      description: 'İzmir vize danışmanlığı alanında özel durumlarınız için birebir profesyonel danışmanlık hizmeti sunuyoruz.',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 mb-16">
          <div className="flex-1">
            <p className="text-sm text-gray-500 font-light mb-3 tracking-wider uppercase">Hizmetlerimiz</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-navy leading-tight">
              Profesyonel Vize
              <br />
              Danışmanlık Hizmetleri
            </h2>
          </div>
          <div className="flex-1 lg:max-w-xl">
            <p className="text-gray-600 leading-relaxed">
              <strong>İzmir vize danışmanlığı</strong> alanında 12 yıllık deneyimimizle tüm vize türlerinde profesyonel destek sunuyoruz. Schengen vizesi, Amerika vizesi, İngiltere vizesi ve daha fazlası için güvenilir çözüm ortağınızız.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-400 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-4xl text-navy group-hover:text-gold transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-semibold text-navy mb-4 group-hover:text-gold transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Link
            to="/hizmetler"
            className="inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-lg whitespace-nowrap"
          >
            Tüm Hizmetleri Görüntüle
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
